import { useState } from 'react';
import { ErrorApi } from '../lib/api.js';
import { Error as AvisoError } from '../piezas/Estados.jsx';
import { useSesion } from '../piezas/Sesion.jsx';

/**
 * Acceso.
 *
 * La sesion viaja en cookie httpOnly: no hay token que guardar en el
 * navegador y el script de la pagina nunca puede leerla.
 */
export function Acceso(): JSX.Element {
  const { entrar } = useSesion();
  const [correo, setCorreo] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [totp, setTotp] = useState('');
  const [pideTotp, setPideTotp] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const [enviando, setEnviando] = useState(false);

  async function alEnviar(evento: React.FormEvent): Promise<void> {
    evento.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      await entrar(correo, contrasena, pideTotp ? totp : undefined);
    } catch (e) {
      /* Si la cuenta tiene segundo factor, el servidor lo pide con su propio
         codigo y la pantalla agrega el campo en lugar de fallar. */
      if (e instanceof ErrorApi && e.codigo === 'ETK-AUT-009') {
        setPideTotp(true);
      } else {
        setError(e);
      }
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="acceso">
      <form className="card" onSubmit={(e) => void alEnviar(e)}>
        <span className="mark" aria-hidden="true">
          E
        </span>
        <h1 style={{ margin: '0 0 4px', fontSize: 19 }}>SCM IDC</h1>
        <p className="muted" style={{ margin: '0 0 20px', fontSize: 12.5 }}>
          Gestion de ingenieria de campo
        </p>

        {error !== null && <AvisoError error={error} />}

        <div className="campo" style={{ marginTop: 14 }}>
          <label htmlFor="correo">Correo</label>
          <input
            id="correo"
            type="email"
            autoComplete="username"
            required
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            data-prueba="correo"
          />
        </div>

        <div className="campo">
          <label htmlFor="contrasena">Contrasena</label>
          <input
            id="contrasena"
            type="password"
            autoComplete="current-password"
            required
            value={contrasena}
            onChange={(e) => setContrasena(e.target.value)}
            data-prueba="contrasena"
          />
        </div>

        {pideTotp && (
          <div className="campo">
            <label htmlFor="totp">Codigo del autenticador</label>
            <input
              id="totp"
              inputMode="numeric"
              autoComplete="one-time-code"
              pattern="[0-9]{6}"
              maxLength={6}
              required
              value={totp}
              onChange={(e) => setTotp(e.target.value)}
              data-prueba="totp"
            />
            <span className="ayuda">Seis digitos de tu aplicacion de autenticacion.</span>
          </div>
        )}

        <button
          type="submit"
          className="btn pri"
          style={{ width: '100%', justifyContent: 'center', marginTop: 6 }}
          disabled={enviando}
          data-prueba="entrar"
        >
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
